export interface ContactType {
    email?: string;
    id: string;
    isExternalUser?: boolean;
    name?: string;
    text?: string;
    type?: string | null | undefined;
    value?: string;
}
